import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store'

// Layout
const Layout = () => import('../layout/index.vue')

// Views
const Login = () => import('../views/login/index.vue')
const Home = () => import('../views/home/index.vue')

// Placeholder page component for all sub-pages
const PlaceholderPage = () => import('../views/placeholder.vue')

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: Home,
        meta: { title: '首页' }
      }
    ]
  },
  // 商品管理
  {
    path: '/product',
    component: Layout,
    meta: { title: '商品管理' },
    children: [
      { path: 'product_list', name: 'product_list', component: () => import('../views/product/product_list.vue'), meta: { title: '商品列表' } },
      { path: 'product_classify', name: 'product_classify', component: () => import('../views/product/product_classify.vue'), meta: { title: '商品分类' } },
      { path: 'product_attr', name: 'product_attr', component: () => import('../views/product/product_attr.vue'), meta: { title: '商品属性' } },
      { path: 'product_brand', name: 'product_brand', component: () => import('../views/product/product_brand.vue'), meta: { title: '品牌管理' } },
      { path: 'product_specs', name: 'product_specs', component: () => import('../views/product/product_specs.vue'), meta: { title: '商品规格' } }
    ]
  },
  // 订单管理
  {
    path: '/order',
    component: Layout,
    meta: { title: '订单管理' },
    children: [
      { path: 'list', name: 'order_list', component: PlaceholderPage, meta: { title: '订单列表' } },
      { path: 'offline', name: 'order_offline', component: PlaceholderPage, meta: { title: '线下订单' } },
      { path: 'refund', name: 'order_refund', component: PlaceholderPage, meta: { title: '退款订单' } },
      { path: 'invoice/list', name: 'order_invoice', component: PlaceholderPage, meta: { title: '发票管理' } }
    ]
  },
  // 用户管理
  {
    path: '/user',
    component: Layout,
    meta: { title: '用户管理' },
    children: [
      { path: 'list', name: 'user_list', component: PlaceholderPage, meta: { title: '用户列表' } },
      { path: 'level', name: 'user_level', component: PlaceholderPage, meta: { title: '等级管理' } },
      { path: 'label', name: 'user_label', component: PlaceholderPage, meta: { title: '用户标签' } }
    ]
  },
  // 财务管理
  {
    path: '/finance',
    component: Layout,
    meta: { title: '财务管理' },
    children: [
      { path: 'capital/index', name: 'finance_capital', component: PlaceholderPage, meta: { title: '资金流水' } },
      { path: 'bill/index', name: 'finance_bill', component: PlaceholderPage, meta: { title: '账单管理' } },
      { path: 'cash/index', name: 'finance_cash', component: PlaceholderPage, meta: { title: '提现管理' } },
      { path: 'finance/set', name: 'finance_set', component: PlaceholderPage, meta: { title: '财务设置' } }
    ]
  },
  // 营销管理
  {
    path: '/marketing',
    component: Layout,
    meta: { title: '营销管理' },
    children: [
      { path: 'coupon', name: 'marketing_coupon', component: PlaceholderPage, meta: { title: '优惠券' } },
      { path: 'promotion', name: 'marketing_promotion', component: PlaceholderPage, meta: { title: '促销活动' } },
      { path: 'lottery', name: 'marketing_lottery', component: PlaceholderPage, meta: { title: '抽奖活动' } },
      { path: 'pointProduct', name: 'marketing_pointProduct', component: () => import('../views/pointProduct/index.vue'), meta: { title: '积分商品' } }
    ]
  },
  // 内容管理
  {
    path: '/content',
    component: Layout,
    meta: { title: '内容管理' },
    children: [
      { path: 'article', name: 'content_article', component: PlaceholderPage, meta: { title: '文章管理' } },
      { path: 'page', name: 'content_page', component: PlaceholderPage, meta: { title: '页面管理' } }
    ]
  },
  // 社区管理
  {
    path: '/community',
    component: Layout,
    meta: { title: '社区管理' },
    children: [
      { path: 'topic', name: 'community_topic', component: PlaceholderPage, meta: { title: '社区话题' } },
      { path: 'content', name: 'community_content', component: PlaceholderPage, meta: { title: '社区内容' } },
      { path: 'comment', name: 'community_comment', component: PlaceholderPage, meta: { title: '社区评论' } },
      { path: 'setting', name: 'community_setting', component: PlaceholderPage, meta: { title: '社区设置' } }
    ]
  },
  // 门店管理
  {
    path: '/store',
    component: Layout,
    meta: { title: '门店管理' },
    children: [
      { path: 'list', name: 'store_list', component: PlaceholderPage, meta: { title: '门店列表' } },
      { path: 'apply', name: 'store_apply', component: PlaceholderPage, meta: { title: '入驻申请' } }
    ]
  },
  // 库存管理
  {
    path: '/stockManage',
    component: Layout,
    meta: { title: '库存管理' },
    children: [
      { path: 'inbound', name: 'stock_inbound', component: PlaceholderPage, meta: { title: '入库管理' } },
      { path: 'outbound', name: 'stock_outbound', component: PlaceholderPage, meta: { title: '出库管理' } },
      { path: 'inventory', name: 'stock_inventory', component: PlaceholderPage, meta: { title: '库存盘点' } }
    ]
  },
  // 供应商
  {
    path: '/supplier',
    component: Layout,
    meta: { title: '供应商' },
    children: [
      { path: 'index', name: 'supplier_list', component: PlaceholderPage, meta: { title: '供应商列表' } },
      { path: 'orderList/index', name: 'supplier_order', component: PlaceholderPage, meta: { title: '供应商订单' } }
    ]
  },
  // 客服管理
  {
    path: '/kefu',
    component: Layout,
    meta: { title: '客服管理' },
    children: [
      { path: 'list', name: 'kefu_list', component: PlaceholderPage, meta: { title: '客服列表' } },
      { path: 'chat', name: 'kefu_chat', component: PlaceholderPage, meta: { title: '聊天记录' } }
    ]
  },
  // 数据统计
  {
    path: '/statistic',
    component: Layout,
    meta: { title: '数据统计' },
    children: [
      { path: 'user', name: 'statistic_user', component: PlaceholderPage, meta: { title: '用户统计' } },
      { path: 'trade', name: 'statistic_trade', component: PlaceholderPage, meta: { title: '交易统计' } },
      { path: 'product', name: 'statistic_product', component: PlaceholderPage, meta: { title: '商品统计' } }
    ]
  },
  // 系统设置
  {
    path: '/system',
    component: Layout,
    meta: { title: '系统设置' },
    children: [
      { path: 'config', name: 'system_config', component: PlaceholderPage, meta: { title: '系统设置' } },
      { path: 'user', name: 'system_user', component: PlaceholderPage, meta: { title: '管理员管理' } },
      { path: 'role', name: 'system_role', component: PlaceholderPage, meta: { title: '角色管理' } },
      { path: 'menu', name: 'system_menu', component: PlaceholderPage, meta: { title: '权限菜单' } },
      { path: 'log', name: 'system_log', component: PlaceholderPage, meta: { title: '系统日志' } }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = store.state.user.token
  if (to.path !== '/login' && !token) {
    next('/login')
  } else if (to.path === '/login' && token) {
    next('/')
  } else {
    next()
  }
})

export default router
